import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../api/api";
import { message, Table, Typography } from "antd";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

interface ProfitsResponse {
  _id: string;
  date: string;
  name: string;
  clientName: string;
  profit: {
    USD: number;
    TJS: number;
  };
  total: number;
  totalCost: {
    USD: number;
    TJS: number;
  };
  netProfitAfter: number;
  netProfitBefore: number;
}

const { Title } = Typography;
export default function Profits() {
  const { startDate, endDate } = useParams();
  const [profits, setProfits] = useState<ProfitsResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchProfits = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/stats/profits`, {
        params: {
          startDate,
          endDate,
        },
      });

      setProfits(response.data);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение инвестиций.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfits();
  }, [startDate, endDate]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Кол-во",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Имя клиента",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Сумма USD",
      dataIndex: "totalCost",
      key: "totalCost",
      render: (totalCost: { USD: number }) =>
        roundToThreeDecimals(totalCost.USD),
    },
    {
      title: "Прибыль USD",
      dataIndex: "profit",
      key: "profit",
      render: (profit: { USD: number }) => roundToThreeDecimals(profit.USD),
    },
    {
      title: "Общ.Прибыль до",
      dataIndex: "netProfitBefore",
      key: "netProfitBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Общ.Прибыль после",
      dataIndex: "netProfitAfter",
      key: "netProfitAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        Прыбиль {startDate} - {endDate}
      </Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={profits}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
